export default function () {
    return {
        userData: null,
        authReady: false,
    }
}